// Import the functions you need from the SDKs you need
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDSqtdRdpjK6-jlJ_DCMp4ffmIOgW9uCjA",
  authDomain: "fiit-tech-social-app.firebaseapp.com",
  projectId: "fiit-tech-social-app",
  storageBucket: "fiit-tech-social-app.appspot.com",
  messagingSenderId: "873962083079",
  appId: "1:873962083079:web:b0490c831ad7f06ff3eba2",
  measurementId: "G-M3DR3CHYYR",
};

// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;
